/*global define*/

define(function () {
    'use strict';

    function OrderElement() {
        return function (input) {
            var results = [],
                objectKey;

            for (objectKey in input) {
                results.push(input[objectKey]);
            }

            results.sort(function (field1, field2) {
                return typeof field1.order === 'function' ? field1.order() - field2.order() : field1.order - field2.order;
            });

            return results;
        };
    }

    OrderElement.$inject = [];

    return OrderElement;
});



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./src/javascripts/ng-admin/Main/component/filter/OrderElement.js
 **/